module.exports = __webpack_public_path__ + "img/w11-b3.9f5682c2.jpg";